/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'n_avatar-checkmark': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle cx="16.2322" cy="16.2317" r="14.0179" fill="#00CC6E" stroke="white" stroke-width="2.5"/><line x1="8.99106" y1="16.6864" x2="13.4553" y2="21.1507" stroke="#F8F8F7" stroke-width="2.5"/><line x1="24.2044" y1="11.2761" x2="13.4901" y2="22.8832" stroke="#F8F8F7" stroke-width="2.5"/>'
  }
})